import React, { useState } from 'react'
import SearchField from '../../../../shared/SearchField'
import CustomButton from '../../../../shared/CustomButton'
import CustomTable from '../../../../shared/CustomTable'
import { EyeIcon } from '../../../../utils/TableActionIcons'
import DropdownField from '../../../../shared/DropdownField'
import {
  dummyRedData,
  GRColumns,
  InventoryItemsData,
  ItemInventoryColumns
} from '../../../../constants/InverntoryConstants'
import { useNavigate } from 'react-router-dom'
import { FaBox, FaBoxOpen, FaCheckCircle } from 'react-icons/fa'
import { FaArrowsTurnRight } from 'react-icons/fa6'
import DatePicker from '../../../../shared/DatePicker'
import ReusableModal from '../../../../shared/ReuseableModal'
import ReceiveForm from './ReceiveForm'
import { useTranslation } from 'react-i18next'

function GoodReceiptList () {
  const navigate = useNavigate()
  const [payloadData, setPayloadData] = useState({
    start_date: null,
    end_date: null
  })

  const { t } = useTranslation()
  const handleChange = (date, name) => {
    setPayloadData({ ...payloadData, [name]: date })
  }
  const [openModal, setOpenModal] = useState(false)

  const ActionTemepelate = rowData => {
    return (
      <div className='flex justify-start gap-2 items-center'>
        <EyeIcon />
        <FaArrowsTurnRight
          size={17}
          className='text-primary cursor-pointer'
          title={t('GrDispatch')}
          onClick={() => navigate(`/requisition-direct-dispatch`)}
        />
        <FaCheckCircle
          size={17}
          className='text-gray-400 cursor-pointer'
          title={t('Receive')}
          onClick={() => setOpenModal(true)}
        />
      </div>
    )
  }

  const action = {
    body: ActionTemepelate,
    header: t('Actions'),
    headerCellClass: '!bg-gray-200'
  }

  const columns = [action, ...GRColumns(t)]

  return (
    <div>
      <div className='flex flex-wrap justify-between w-full gap-4 items-center'>
        <div className='w-full sm:w-auto'>
          <SearchField className='w-full sm:w-[300px]' placeholder='Search' />
        </div>

        <div className='flex flex-wrap justify-start w-full gap-3 items-start sm:w-auto'>
          <DatePicker
            name='start_date'
            placeholder={t('Startdate')}
            useFormik={false}
            className='w-full sm:w-[200px]'
            onChange={e => handleChange(e.target.value, 'start_date')}
          />
          <DatePicker
            name='end_date'
            placeholder={t('Enddate')}
            useFormik={false}
            className='w-full sm:w-[200px]'
            onChange={e => handleChange(e.target.value, 'end_date')}
          />

          <CustomButton
            label={t('ApplyFilters')}
            icon={'pi pi-filter'}
            className='h-[35px] w-full sm:w-fit'
          />
        </div>
      </div>
      <div className='mt-4'>
        <CustomTable columns={columns} data={InventoryItemsData} />
      </div>
      <div>
        <ReusableModal
          isVisible={openModal}
          position='top'
          title={t('ReceiveItem')}
          HeaderIcon={FaBox}
          onClose={() => {
            setOpenModal(false)
          }}
        >
          <ReceiveForm closeModal={() => setOpenModal(false)} />
        </ReusableModal>
      </div>
    </div>
  )
}

export default GoodReceiptList
